export default "__VITE_ASSET__KL2w_hUO__"